import { useState } from "react";
import { MapPin, Clock, MessageCircle } from "lucide-react"; // Add MessageCircle icon
import "./mosqueCard.scss";
import MosqueModal from "./MosqueModal.js";
import { useNavigate } from "react-router-dom";
import { publicRequest } from "../requestMethods";

const MosqueCard = ({ mosque }) => {
  const [expanded, setExpanded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // const openGoogleMaps = () => {
  //   window.open(
  //     `https://www.google.com/maps?q=${mosque.location.latitude},${mosque.location.longitude}`,
  //     "_blank"
  //   );
  // };
  const openGoogleMaps = (e) => {
    e?.stopPropagation();
    if (mosque.googleMapsLink) {
      const user = JSON.parse(localStorage.getItem('user'));
      publicRequest.post(`/mosques/record-directions/${mosque.mosqueID}`, {
        user: user ? { name: user.name, email: user.email, googleId: user.googleId || user.sub, picture: user.picture } : null
      }).catch(() => {});
      window.open(mosque.googleMapsLink, "_blank");
    } else {
      console.error("No map link available");
    }
  };


  const toggleDescription = () => {
    setExpanded(!expanded);
  };

  const getShortDescription = (text, wordLimit) => {
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };
  const handleCardClick = (e) => {
    // Don't navigate if clicking on map icon or description
    if (
      !e.target.closest('.mosque-card__map-icon') &&
      !e.target.closest('.mosque-card__description')
    ) {
      navigate(`/mosque/${mosque.mosqueID}`);
    }
  };

  return (
    <div className="mosque-card" onClick={handleCardClick}  >

      {/* Google Maps Icon */}
      <MapPin size={20} className="mosque-card__map-icon" onClick={openGoogleMaps} />

      <div className="mosque-card__content">
        <div className="mosque-card__header">
          {mosque.verified && (
            <span className="mosque-card__verified-badge">
              <svg viewBox="0 0 24 24" fill="none" className="verified-icon">
                <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Verified
            </span>
          )}
          <h2 className="mosque-card__name">{mosque.name}</h2>
        </div>
        
        <p className="mosque-card__location">{mosque.district}, {mosque.state}</p>

        {mosque.distance && <p className="mosque-card__distance">📍 {mosque.distance.toFixed(2)} km away</p>}

        {mosque.description && (
          <div className="mosque-card__description-wrapper">
            <p
              className="mosque-card__description"
              onClick={toggleDescription}
              title="Click to expand"
            >
              {expanded ? mosque.description : getShortDescription(mosque.description, 30)}
            </p>
            {mosque.description && mosque.description.split(' ').length > 30 && (
              <span className="mosque-card__expand-hint">
                {expanded ? 'Show less' : 'Read more'}
              </span>
            )}
          </div>
        )}

        <div className="mosque-card__footer">
          <div className="mosque-card__footer-left">
            <span className="mosque-card__updated">
              <Clock size={16} />
              {formatDate(mosque.date)}
            </span>
          </div>

          <div className="mosque-card__comments" title={`${mosque.comments?.length || 0} Comments`}>
            <MessageCircle size={16} />
            <span className="comment-count">{mosque.comments?.length || 0}</span>
            <div className="tooltip">
              {mosque.comments?.length || 0} Comments
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && <MosqueModal mosque={mosque} onClose={() => setIsModalOpen(false)} />}
    </div>
  );
};

export default MosqueCard;
